import React from "react";

const Logo = ({ fill = "none", height = "32" }) => {
  return (
    <svg
      id="Logo"
      xmlns="http://www.w3.org/2000/svg"
      width="116.864"
      height={height}
      viewBox="0 0 116.864 22.52"
    >
      <g id="Group_50955" data-name="Group 50955">
        <path
          id="Path_206690"
          data-name="Path 206690"
          d="M39.492.321H51.509V4.06H43.471V7.8h6.7v3.739h-6.7v3.739h8.038v3.739H39.492Zm37.978,0H73.491V19.014H84.868V15.276h-7.4ZM65.406,11.991c0,2.163-1.175,3.525-3.391,3.525-2.243,0-3.391-1.362-3.391-3.5V.321H54.644V12.045c0,4.379,2.617,7.317,7.371,7.317,4.7,0,7.371-2.991,7.371-7.344V.321H65.406Zm51.458,7.023h-4.54l-3.445-6.756h-1.9v6.756H103V.321h6.436c3.926,0,6.676,2.35,6.676,5.848a5.711,5.711,0,0,1-3.338,5.474ZM111.977,6.25c0-1.2-.828-2.217-2.617-2.217h-2.377v4.62h2.51a2.278,2.278,0,0,0,2.484-2.4M87.414,19.014H99.432V15.276H91.393V11.537h6.7V7.8h-6.7V4.06h8.038V.321H87.414ZM0,19.014H20.541l1.872-5.139L.244,18.344Zm2.526-6.938H23.067l1.871-5.139L2.77,11.407ZM5.052,5.139H25.593L27.464,0,5.3,4.469Z"
          fill="#fff"
        />
        <g
          id="Component_11_33"
          data-name="Component 11 – 33"
          transform="translate(0 3.158)"
        >
          <rect
            id="Rectangle_19401"
            data-name="Rectangle 19401"
            width="116.864"
            height="19.362"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;
